import { jsx as l } from "react/jsx-runtime";
const v = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.75 1.5h-1.5v1.418h1.5V1.5Zm2.079 3.671A3.987 3.987 0 0 0 8 4a4 4 0 1 0 2.829 1.171ZM9.768 9.768c-.472.473-1.1.732-1.768.732-.667 0-1.295-.26-1.768-.732A2.484 2.484 0 0 1 5.5 8c0-.668.26-1.296.733-1.769A2.484 2.484 0 0 1 8.001 5.5c.667 0 1.295.26 1.768.731.472.473.732 1.1.732 1.769 0 .668-.26 1.295-.733 1.768ZM1.5 7.239h1.43v1.5H1.5v-1.5Zm5.75 5.821V14.5h1.5v-1.441h-1.5Zm5.82-5.82h1.43v1.5h-1.43v-1.5Zm-1.049-4.332-.966.966 1.061 1.06.966-.965-1.06-1.061Zm-9.103 1.06 1.06-1.06.967.966-1.061 1.06-.966-.966Zm.966 7.077-.966.966 1.061 1.06.966-.966-1.06-1.06Zm7.171 1.06 1.06-1.06.967.965-1.061 1.061-.966-.966Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  v as Sun
};
